import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "../../stylesheets/components/header/nav/navMob.scss";
import "../../assets/icons/edel_icons/style.scss";
const MobStickyBottom = ({ isMainPage }) => {
    const showFooter = useSelector((state) => state.footer.showFooter);
    return (React.createElement(React.Fragment, null,
        React.createElement("section", { className: "mob-fixed-bottom", style: { display: showFooter ? "block" : "none" } },
            React.createElement("div", { className: "mob-bottom-block mob-bottom-refactor" },
                React.createElement("div", { className: "tab  tab-left" },
                    React.createElement("ul", { className: "d-flex gap-30" },
                        React.createElement("li", null,
                            React.createElement(Link, { to: "/markets" },
                                React.createElement("div", { className: "bt-icon" },
                                    React.createElement("span", { className: "edel-icon-markets" })),
                                React.createElement("div", { className: "bt-text" },
                                    React.createElement("span", null, "Markets")))),
                        React.createElement("li", null,
                            React.createElement(Link, { to: "/watchlist" },
                                React.createElement("div", { className: "bt-icon" },
                                    React.createElement("span", { className: "edel-icon-watchlist-star" })),
                                React.createElement("div", { className: "bt-text" },
                                    React.createElement("span", null, "Watchlist")))),
                        React.createElement("li", null,
                            React.createElement(Link, { to: "/MobMenu" },
                                React.createElement("div", { className: "bt-icon" },
                                    React.createElement("span", { className: "edel-icon-menu" })),
                                React.createElement("div", { className: "bt-text" },
                                    React.createElement("span", null, "Menu")))),
                        React.createElement("li", null,
                            React.createElement(Link, { to: "/search" },
                                React.createElement("div", { className: "bt-icon" },
                                    React.createElement("span", { className: "edel-icon-search1" })),
                                React.createElement("div", { className: "bt-text" },
                                    React.createElement("span", null, "Search")))),
                        React.createElement("li", null,
                            React.createElement(Link, { to: "" },
                                React.createElement("div", { className: "bt-icon" },
                                    React.createElement("span", { className: "edel-icon-home-3" })),
                                React.createElement("div", { className: "bt-text" },
                                    React.createElement("span", null, "Home"))))))))));
};
export default MobStickyBottom;
